/* @flow */
import { rem } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { phablet, lap } from '@braindate/ui/lib/token/mediaQuery';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    maxWidth: 200,

    [lap]: {
      maxWidth: 240,
    },
  },
  info: {
    color: ({ theme }: ThemeFunction) => theme.textColor,
  },
  title: {
    display: 'block',
    fontSize: rem(12, baseFontSize),
    fontWeight: 500,
    marginBottom: 0,

    [phablet]: {
      fontSize: rem(14, baseFontSize),
    },
  },
  titleName: {
    marginRight: 12,
  },
  name: {
    display: 'block',
    fontSize: rem(12, baseFontSize),
    fontWeight: 700,
    marginTop: '0.8em',

    [phablet]: {
      fontSize: rem(16, baseFontSize),
    },
  },
};
